import { useRef, useState } from 'react';

import { accordionData } from '../data/data';
import slots from '../assets/view-slot-machines-casino.png';

const ComparisonSection = () => {
  const [openId, setOpenId] = useState("2090");
  const handleToggle = (id, e) => {
    e.preventDefault(); 
    setOpenId(prevId => (prevId === id ? null : id));
  };

  return (
    <div className="elementor-element elementor-element-2e18894 e-flex e-con-boxed e-con e-parent" data-id="2e18894" data-element_type="container">
      <div className="e-con-inner">
        <div className="elementor-element elementor-element-93c3678 e-con-full e-flex e-con e-child" data-id="93c3678" data-element_type="container">
          <div className="elementor-element elementor-element-0ac3a20 elementor-widget elementor-widget-image" data-id="0ac3a20" data-element_type="widget" data-widget_type="image.default">
            <div className="elementor-widget-container">
              <img loading="lazy" decoding="async" width="800" height="608" src={slots} className="attachment-large size-large wp-image-3667" alt="" />
            </div>
          </div>
        </div>

        <div className="elementor-element elementor-element-b88aae0 e-con-full e-flex e-con e-child" data-id="b88aae0" data-element_type="container">
          <div className="elementor-element elementor-element-e67cbca elementor-widget elementor-widget-heading" data-id="e67cbca" data-element_type="widget" data-widget_type="heading.default">
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">Como Comparamos os Casinos Online de Portugal</h2>
            </div>
          </div>
          
          <div className="elementor-element elementor-element-f6842f5 elementor-widget elementor-widget-text-editor" data-id="f6842f5" data-element_type="widget" data-widget_type="text-editor.default">
            <div className="elementor-widget-container">
              Ao criar esta lista, consideramos vários fatores chave para ajudá-lo a selecionar os melhores casinos online para as suas necessidades. Eis o que levámos em conta:
            </div>
          </div>

          <div className="elementor-element elementor-element-c7578ae elementor-widget elementor-widget-n-accordion" 
               data-id="c7578ae" 
               data-element_type="widget" 
               data-settings='{"max_items_expended":"one"}'>
            <div className="elementor-widget-container">
              <div className="e-n-accordion">
                
                {accordionData.map((item, index) => (
                  <AccordionItem 
                    key={item.id}
                    item={item}
                    index={index}
                    isOpen={openId === item.id}
                    onToggle={(e) => handleToggle(item.id, e)}
                  />
                ))}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AccordionItem = ({ item, index, isOpen, onToggle }) => {
  const detailsRef = useRef(null);
  const summaryRef = useRef(null);
  const contentRef = useRef(null);

  return (
    <details 
      ref={detailsRef}
      id={`e-n-accordion-item-${item.id}`} 
      className="e-n-accordion-item" 
      open={isOpen}
    >
      <summary 
        ref={summaryRef}
        className="e-n-accordion-item-title" 
        data-accordion-index={index + 1} 
        aria-expanded={isOpen} 
        onClick={onToggle}
      >
        <span className="e-n-accordion-item-title-header">
          <div className="e-n-accordion-item-title-text">{item.title}</div>
        </span>
      </summary>
      <div 
        ref={contentRef}
        role="region" 
        className={`elementor-element elementor-element-${item.containerId} e-con-full e-flex e-con e-child`}
      >
        <div className={`elementor-element elementor-element-${item.widgetId} elementor-widget elementor-widget-text-editor`}>
          <div className="elementor-widget-container">
            {item.content}
          </div>
        </div>
      </div>
    </details>
  );
};

export default ComparisonSection;